import { render, staticRenderFns } from "./ItemDetails.vue?vue&type=template&id=7055d22f&scoped=true"
import script from "./ItemDetails.vue?vue&type=script&lang=js"
export * from "./ItemDetails.vue?vue&type=script&lang=js"
import style0 from "./ItemDetails.vue?vue&type=style&index=0&id=7055d22f&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7055d22f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\BabaBello\\bababelloapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7055d22f')) {
      api.createRecord('7055d22f', component.options)
    } else {
      api.reload('7055d22f', component.options)
    }
    module.hot.accept("./ItemDetails.vue?vue&type=template&id=7055d22f&scoped=true", function () {
      api.rerender('7055d22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ItemDetails.vue"
export default component.exports